import { IAppContext } from 'App/AppContext';
import { getEntity } from 'globalFunctions';
import Entity from 'models/entity';
import Objective from 'models/objective/objective';
import Process from 'models/process/process';
import ProcessingActivity from 'models/processingActivity';
import { apiGetTaskContext } from 'services/Api/taskService';
import { apiRequest } from 'services/Auth/authConfig';
import Asset from '../asset/asset';
import Control from '../control';
import Risk from '../risk';
import Theme from '../theme';
import Task from './task';
import { TaskRelation } from './taskRelation';

export class TaskContext {
  controls: Control[];

  themes: Theme[];

  processes: Process[];

  objectives: Objective[];

  risks: Risk[];

  assets: Asset[];

  taskRelations: TaskRelation[];

  processingActivities: ProcessingActivity[];

  constructor() {
    this.controls = [];
    this.themes = [];
    this.risks = [];
    this.processes = [];
    this.risks = [];
    this.objectives = [];
    this.assets = [];
    this.taskRelations = [];
    this.processingActivities = [];
  }
}

export async function addTaskContextFrom(output: Task, taskId: number, appContext: IAppContext) {
  //
  // Add the related entities of this with Id taskId to the output task
  // This can only work for tasks that already exist
  //
  if (taskId !== -1) {
    const accessToken = await appContext.getAccessToken(apiRequest.scopes);
    const context = await apiGetTaskContext(taskId, accessToken, appContext);

    //create entities from the context so that the context tab does not have the load them
    const newRelatedEntities: Entity[] = [];
    newRelatedEntities.push(...context.assets.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.risks.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.controls.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.themes.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.processes.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.objectives.map((a) => getEntity(a)));
    newRelatedEntities.push(...context.processingActivities.map((a) => getEntity(a)));

    output.relatedEntities = newRelatedEntities;

    //And add the Ids if they do not exist yet in the template
    output.controlIds.push(
      ...context.controls.filter((c) => !output.controlIds.includes(c.controlId)).map((c) => c.controlId),
    );
    output.controlIds.push(
      ...context.themes.filter((c) => !output.controlIds.includes(c.themeId)).map((c) => c.themeId),
    );
    output.riskIds.push(...context.risks.filter((r) => !output.riskIds.includes(r.riskId)).map((r) => r.riskId));
    output.assetIds.push(...context.assets.filter((a) => !output.assetIds.includes(a.assetId)).map((a) => a.assetId));
    output.objectiveIds.push(
      ...context.objectives.filter((o) => !output.objectiveIds.includes(o.objectiveId)).map((o) => o.objectiveId),
    );
    output.processIds.push(
      ...context.processes.filter((p) => !output.processIds.includes(p.processId)).map((p) => p.processId),
    );
    output.processingActivityIds.push(
      ...context.processingActivities
        .filter((pa) => !output.processingActivityIds.includes(pa.processingActivityId))
        .map((pa) => pa.processingActivityId),
    );
  }

  return output;
}
